import { VehicleUpgrade } from "@1games-ru/region-shared/dist/types/vehicle/vehicle";
import { AnimatePresence, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Button, Icon } from "@/shared/ui";

type Props = {
  upgrade: VehicleUpgrade;
  maxInventoryWeight: number;
  vin: string;
  onClose: () => void;
};

export default function OfferVehicleUpgrade({ upgrade, maxInventoryWeight, vin, onClose }: Props) {
  const { t } = useTranslation("offer");
  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: "100%" }}
        animate={{ y: 0 }}
        exit={{ y: "100%" }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        className="absolute z-10 bottom-0 left-0 flex flex-col size-full max-h-full overflow-y-auto bg-dark-900/84"
        style={{ backdropFilter: "blur(2px)" }}
      >
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          className="mt-auto px-7.5 pt-6.5 pb-7.5 bg-dark-900 rounded-4 shadow-[0px_0px_180px_0px_rgba(171,41,41,0.3)]"
        >
          <div className="flex justify-between items-center mb-3.5">
            <p>{t("offer.vehicle.upgrade.title")}</p>
            <Button
              color="gray"
              variant="soft"
              className="flex items-center justify-center w-[2rem] h-[2rem] p-0"
              onClick={onClose}
            >
              <Icon name="close" className="w-3" />
            </Button>
          </div>
          <div className="flex flex-col gap-1.5">
            {Object.entries(upgrade).map((item) => {
              const upgradeKey = item[0];
              const upgradeLvl = item[1];

              return (
                <motion.div
                  key={upgradeKey}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className="flex justify-between items-center h-11 px-3.5 py-2.5 bg-dark-800/50 border border-dashed border-[#1A1A1A] rounded-xl"
                >
                  <div className="flex items-center gap-2.5">
                    <Icon category="vehicle" name={upgradeKey.toLowerCase()} className="w-5.5" />
                    <p className="text-12 font-bold text-white/50 uppercase">
                      {t(`offer.vehicle.upgrade.${upgradeKey}`)}:
                    </p>
                  </div>
                  <p className="text-12 font-bold text-accent-solid uppercase">
                    {upgradeLvl} {t("offer.vehicle.upgrade.level")}
                  </p>
                </motion.div>
              );
            })}
          </div>
          <div className="flex justify-between mb-4 pt-5 pb-4 px-1 font-bold uppercase border-b border-[#191919]">
            <p className="text-11 text-white/30">{t("offer.vehicle.upgrade.maxInventoryWeight")}</p>
            <p className="flex gap-1 text-12 text-accent-solid">
              {maxInventoryWeight}
              <span className="text-white">KG</span>
            </p>
          </div>
          <div className="flex justify-between px-1 font-bold uppercase">
            <p className="text-11 text-white/30">{t("offer.vehicle.upgrade.vin")}</p>
            <p className="text-12 text-white/50">{vin}</p>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
